import { createFileRoute } from '@tanstack/react-router';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/w/entities/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'created', sortDir: 'desc' }),
});
